export const storeTableHeader = [
    {
        headerName: "Store Name",
        field: 'storeName',
        sortable: true,
        // width: 150,
        headerTooltip: 'Store Name',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    // {
    //     headerName: "Brand Name",
    //     field: 'nameBrand',
    //     sortable: true,
    //     width: 130,
    //     headerTooltip: 'Brand Name',
    //     filterParams: {
    //         buttons: ["reset", "apply"],
    //         filterOptions: ["contains"],
    //         suppressAndOrCondition: true,
    //     },
    // },
    // {
    //     headerName: "Opening Status",
    //     field: 'openingStatus',
    //     sortable: true,
    //     // headerComponentFramework: OpeningStatusFilter,
    //     width: 170,
    //     headerTooltip: 'Opening Status',
    //     filterParams: {
    //         buttons: ["reset", "apply"],
    //         filterOptions: ["contains"],
    //         suppressAndOrCondition: true,
    //     },
    // },
    // {
    //     headerName: "Class",
    //     field: 'storeClass',
    //     sortable: true,
    //     width: 100,
    //     headerTooltip: 'Class',
    //     filterParams: {
    //         buttons: ["reset", "apply"],
    //         filterOptions: ["contains"],
    //         suppressAndOrCondition: true,
    //     },
    // },
    {
        headerName: "Classification",
        field: 'classification',
        sortable: true,
        // width: 140,
        headerTooltip: 'Classification',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "City",
        field: 'city',
        sortable: true,
        // width: 100,
        headerTooltip: 'City',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Area",
        field: 'area',
        sortable: true,
        // width: 100,
        headerTooltip: 'Area',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    // {
    //     headerName: "Business Model",
    //     field: 'businessModel',
    //     sortable: true,
    //     width: 160,
    //     headerTooltip: 'Business Model',
    //     filterParams: {
    //         buttons: ["reset", "apply"],
    //         filterOptions: ["contains"],
    //         suppressAndOrCondition: true,
    //     },
    // },
    // {
    //     headerName: "Channel",
    //     field: 'channel',
    //     sortable: true,
    //     width: 150,
    //     headerTooltip: 'Channel',
    //     filterParams: {
    //         buttons: ["reset", "apply"],
    //         filterOptions: ["contains"],
    //         suppressAndOrCondition: true,
    //     },
    // },
    {
        headerName: "Opening Date",
        field: 'openingDate',
        sortable: true,
        // width: 150,
        headerTooltip: 'Opening Date',
        filter: false
    },
    // {
    //     headerName: "Display Options",
    //     field: 'displayOptions',
    //     sortable: true,
    //     width: 120,
    //     headerTooltip: 'Display Options',
    //     filter: false,
    // },
    // {
    //     headerName: "Display Qty",
    //     field: 'displayQty',
    //     sortable: true,
    //     width: 120,
    //     headerTooltip: 'Display Qty',
    //     filter: false,
    // },
    // {
    //     headerName: "Fresh Margin Type",
    //     field: 'freshMarginType',
    //     sortable: true,
    //     width: 120,
    //     headerTooltip: 'Fresh Margin Type',
    //     filter: false,
    // },
    // {
    //     headerName: "Fresh Margin",
    //     field: 'freshMargin',
    //     sortable: true,
    //     width: 120,
    //     headerTooltip: 'Fresh Margin',
    //     filter: false,
    // },
    // {
    //     headerName: "EOSS Margin Type",
    //     field: 'eossMarginType',
    //     sortable: true,
    //     width: 120,
    //     headerTooltip: 'EOSS Margin Type',
    //     filter: false,
    // },
    // {
    //     headerName: "EOSS Margin",
    //     field: 'eossMargin',
    //     sortable: true,
    //     width: 120,
    //     headerTooltip: 'EOSS Margin',
    //     filter: false,
    // },
    {
        headerName: "Profile Status",
        field: 'profileStatus',
        sortable: true,
        // width: 150,
        headerTooltip: 'Profile Status',
        filter: false,
    },
    {
        headerName: "Action",
        field: 'action',
        sortable: false,
        filter: false
    },
];

export const brandTableHeader = [
    {
        headerName: "Brand Name",
        field: 'brandName',
        sortable: true,
        width: 150,
        headerTooltip: 'Brand Name',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Brand Deck",
        field: 'brandDeck',
        sortable: true,
        headerTooltip: 'Brand Deck',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Email Id",
        field: 'emailId',
        sortable: true,
        headerTooltip: 'Email Id',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "GSTIN",
        field: 'gstIn',
        sortable: true,
        headerTooltip: 'GSTIN',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "PAN No",
        field: 'pan',
        sortable: true,
        width: 150,
        headerTooltip: 'PAN Number',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Product Type",
        field: 'productType',
        sortable: true,
        width: 150,
        headerTooltip: 'Product Type',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Brand Ph.No",
        field: 'brandPhoneNo',
        sortable: true,
        width: 150,
        headerTooltip: 'Brand Ph.No',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Business Model",
        field: 'businessModel',
        sortable: true,
        width: 160,
        headerTooltip: 'Business Model',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Tek - Contact Name",
        field: 'productPersonName',
        sortable: true,
        headerTooltip: 'Tek - Contact Name',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Tek - Contact Phone No.",
        field: 'productPersonPhoneNo',
        sortable: true,
        width: 150,
        headerTooltip: 'Tek - Contact Phone No.',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Tek - Contact Department",
        field: 'productPersonDepartment',
        sortable: true,
        width: 150,
        headerTooltip: 'Tek - Contact Department',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Tek - Contact Email Id",
        field: 'productPersonEmailId',
        sortable: true,
        headerTooltip: 'Tek - Contact Email Id',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Brand Status",
        field: 'brandStatus',
        sortable: true,
        width: 150,
        headerTooltip: 'Brand Status',
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Profile Status",
        field: 'profileStatus',
        sortable: true,
        width: 150,
        headerTooltip: 'Profile Status',
        filter: false
    },
    {
        headerName: "Action",
        field: 'action',
        actionFor: "reconReport-brandManagement",
        sortable: false,
        filter: false
    },
    
];

export const userTableHeader = [
    {
        headerName: "User Name",
        field: 'userName',
        sortable: true,
        filter: true
    },
    {
        headerName: "Designation",
        field: 'designation',
        sortable: true,
        filter: true
    },
    {
        headerName: "Mobile Number",
        field: 'mobileNumber',
        sortable: true,
        filter: true
    },
    {
        headerName: "Years Of Experience",
        field: 'experience',
        sortable: true,
        filter: true
    },
    {
        headerName: "City",
        field: 'city',
        sortable: true,
        filter: true
    },
    {
        headerName: "Region",
        field: 'region',
        sortable: true,
        filter: true
    },
    {
        headerName: "Store Count",
        field: 'storeCount',
        sortable: true,
        filter: true
    },
    {
        headerName: "Store Name",
        field: 'nameStore',
        sortable: true,
        filter: true
    },
    {
        headerName: "Brand Name",
        field: 'nameBrand',
        sortable: true,
        filter: true
    },
    {
        headerName: "Action",
        field: 'action',
        sortable: false,
        filter: false,
    },
]

export const salesConsolidatedTableHeader = [
    // {
    //     headerName: "Month",
    //     field: 'month',
    //     // sortable: true,
    // },
    {
        headerName: "Brand Name",
        field: 'nameBrand',
        filter: true,
        filterParams: {
            buttons: ["clear", "apply"],
        },
    },
    // {
    //     headerName: "Updated On",
    //     field: 'updatedAt',
    // },
    {
        headerName: "Consolidated Record",
        field: 'passRecord',
        // sortable: true,
    },
    {
        headerName: "Error Record",
        field: 'errorRecord',
        // sortable: true,
    },
]
export const salesRecConsolidatedTableHeader = [
    {
        headerName: "Month",
        field: 'month',
        // sortable: true,
    },
    {
        headerName: "Brand Name",
        field: 'nameBrand',
        filter: true,
        filterParams: {
            buttons: ["clear", "apply"],
        },
    },
    {
        headerName: "Updated On",
        field: 'updatedAt',
        // sortable: true,
    },
    {
        headerName: "Consolidated Record",
        field: 'passRecord',
        // sortable: true,
        for: 'sales'
    },
    // {
    //     headerName: "YTD Reports",
    //     field: 'ytdReport',
    //     // sortable: true,
    //     for: 'ytd'
    // },
    {
        headerName: "Error Record",
        field: 'errorRecord',
        // sortable: true,
    },
    {
        headerName: "Recon Report",
        field: 'reconReport',
        // sortable: true,
    },
]

export const salesUnprocessedTableHeader = [
    {
        headerName: "Date",
        field: 'date',
        // sortable: true,
    },
    {
        headerName: "Email Id",
        field: 'emailId',
        // sortable: true,
    },
    {
        headerName: "Failed Record",
        field: 'failedRecord',
        // sortable: true,
    }
];
export const salesCustomTableHeader = [
    // {
    //     headerName: "Brand",
    //     field: 'brand',
    //     // sortable: true,
    // },
    // {
    //     headerName: "Store",
    //     field: 'store',
    //     // sortable: true,
    // },
    // {
    //     headerName: "Date Range",
    //     field: 'dateRange',
    //     // sortable: true,
    // },
    {
        headerName: "Description",
        field: 'description',
        // sortable: true,
    },
    {
        headerName: "Download",
        field: 'download',
        // sortable: true,
    }
];

export const rulesMangmentViewTableHeader = [
    {
        headerName: "Report Type",
        field: 'reportTypeName',
        // width: 120
        // sortable: true,
    },
    // {
    //     headerName: "Brand Name",
    //     field: 'reportTypeBrandName',
    //     width: 150
    //     // width: 'calc(100% - 200px)',
    //     // sortable: true,
    // },
    {
        headerName: "Store Name",
        field: 'reportTypeStoreName',
        // width: 213,
        // width: 213
        // sortable: true,
    },
    {
        headerName: "Action",
        field: 'action',
        // width: 85,
        actionFor: 'rulesMangment',
        // width: 70,
        // sortable: true,
    },
];
export const feedbackTableHeader = [
    {
        headerName: "Employee ID",
        field: 'employeeId',
        sortable: true,
        headerTooltip: 'Employee ID',
        width: 150
    },
    {
        headerName: "Name",
        field: 'name',
        sortable: true,
        headerTooltip: 'Name'
    },
    {
        headerName: "Brand Name",
        field: 'feedbackBrandName',
        sortable: true,
        headerTooltip: 'Brand Name'
    },
    {
        headerName: "Store Name",
        field: 'feedbackStoreName',
        sortable: true,
        headerTooltip: 'Store Name'
    },
    {
        headerName: "Created Date",
        field: 'createdDate',
        sortable: true,
        headerTooltip: 'Created Date'
    },
    {
        headerName: "Area",
        field: 'area',
        sortable: true,
        headerTooltip: 'Area',
        width: 100
    },
    {
        headerName: "City",
        field: 'city',
        sortable: true,
        headerTooltip: 'City',
        width: 100
    },
    {
        headerName: "Title",
        field: 'title',
        sortable: true,
        headerTooltip: 'Title',
        width: 140
    },
    {
        headerName: "Feedback Status",
        field: 'feedbackStatus',
        // sortable: true,
        headerTooltip: 'Feedback Status',
        filter: false,
    },
    {
        headerName: "Action",
        field: 'feedbackAction',
        actionFor: 'feedback',
        filter: false,
        width: 120,
        // sortable: true,
    },
];

export const ProductSKUHeader = [
    // {
    //     headerName: "Brand Name",
    //     field: 'nameBrand',
    //     sortable: true,
    //     headerTooltip: 'Brand Name',
    // },
    {
        headerName: "Product",
        field: 'product',
        sortable: true,
        headerTooltip: 'Product',
    },
    {
        headerName: "Style Code",
        field: 'sku',
        sortable: true,
        headerTooltip: 'Style Code',
    },
    {
        headerName: "Gross Sales",
        field: 'grossSales',
        sortable: true,
        headerTooltip: 'Gross Sales',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.grossSalesRaw || 0;
            const numB = nodeB.data.grossSalesRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Net Sales",
        field: 'netSales',
        sortable: true,
        headerTooltip: 'Net Sales',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.netSalesRaw || 0;
            const numB = nodeB.data.netSalesRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Net Unit Sold",
        field: 'netUnitSold',
        sortable: true,
        headerTooltip: 'Net Unit Sold',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.netUnitSoldRaw || 0;
            const numB = nodeB.data.netUnitSoldRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Discount",
        field: 'discount',
        sortable: true,
        headerTooltip: 'Discount',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.discountRaw || 0;
            const numB = nodeB.data.discountRaw || 0;
            return numA - numB;
        },
    },
]
export const TopPerformingCategoryHeader = [
    {
        headerName: "Category",
        field: 'category',
        sortable: true,
        headerTooltip: 'Category',
    },
    {
        headerName: "Gross Sales",
        field: 'grossSales',
        sortable: true,
        headerTooltip: 'Gross Sales',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.grossSalesRaw || 0;
            const numB = nodeB.data.grossSalesRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Net Sales",
        field: 'netSales',
        sortable: true,
        headerTooltip: 'Net Sales',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.netSalesRaw || 0;
            const numB = nodeB.data.netSalesRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Net Unit Sold",
        field: 'netUnitSold',
        sortable: true,
        headerTooltip: 'Net Unit Sold',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.netUnitSoldRaw || 0;
            const numB = nodeB.data.netUnitSoldRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Discount",
        field: 'discount',
        sortable: true,
        headerTooltip: 'Discount',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.discountRaw || 0;
            const numB = nodeB.data.discountRaw || 0;
            return numA - numB;
        },
    },
]

export const BrandWiseSalesHeader = [
    {
        headerName: "Store Name",
        field: 'nameStore',
        sortable: true,
        headerTooltip: 'Store Name',
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Latest Invoice Date",
        field: 'invDate',
        headerTooltip: 'Latest Invoice Date',
        width: 120,
        sortable: true,
    },
    {
        headerName: "Last Updated Date",
        field: 'lastUpdated',
        headerTooltip: 'Last Updated Date',
        width: 130,
        sortable: true,
    },
    {
        headerName: "Net Unit Sold",
        field: 'netUnitSold', // This keeps the formatted display
        sortable: true,
        headerTooltip: 'Net Unit Sold',
        width: 100,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.netUnitSoldRaw || 0;
            const numB = nodeB.data.netUnitSoldRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Total MRP Value",
        field: 'mrpValue',
        sortable: true,
        headerTooltip: 'Total MRP Value',
        width: 150,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.mrpValueRaw || 0;
            const numB = nodeB.data.mrpValueRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Discount",
        field: 'discount',
        sortable: true,
        headerTooltip: 'Discount',
        width: 100,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.discountRaw || 0;
            const numB = nodeB.data.discountRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Gross Sales",
        field: 'grossSale',
        sortable: true,
        headerTooltip: 'Gross Sales',
        width: 130,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.grossSaleRaw || 0;
            const numB = nodeB.data.grossSaleRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Net Sales",
        field: 'netSale',
        sortable: true,
        headerTooltip: 'Net Sales',
        width: 130,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.netSaleRaw || 0;
            const numB = nodeB.data.netSaleRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "ASP",
        field: 'asp',
        sortable: true,
        headerTooltip: 'ASP',
        width: 120,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.aspRaw || 0;
            const numB = nodeB.data.aspRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Count of bill",
        field: 'cob',
        sortable: true,
        headerTooltip: 'Count of bill',
        width: 120,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.cobRaw || 0;
            const numB = nodeB.data.cobRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "ATV",
        field: 'asv',
        sortable: true,
        headerTooltip: 'ATV',
        width: 120,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.asvRaw || 0;
            const numB = nodeB.data.asvRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "BS",
        field: 'bs',
        sortable: true,
        headerTooltip: 'BS',
        width: 100,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.bsRaw || 0;
            const numB = nodeB.data.bsRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Sell Through",
        field: 'sellThrough',
        sortable: true,
        headerTooltip: 'Sell Through',
        width: 150,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.sellThroughRaw || 0;
            const numB = nodeB.data.sellThroughRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Return Unit",
        field: 'returnUnit',
        sortable: true,
        headerTooltip: 'Return Unit',
        width: 110,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.returnUnitRaw || 0;
            const numB = nodeB.data.returnUnitRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Return Value",
        field: 'returnValue',
        sortable: true,
        headerTooltip: 'Return Value',
        width: 130,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.returnValueRaw || 0;
            const numB = nodeB.data.returnValueRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Total Tgt Value",
        field: 'totalTgtValue',
        sortable: true,
        headerTooltip: 'Total Tgt Value',
        width: 130,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.totalTgtValueRaw || 0;
            const numB = nodeB.data.totalTgtValueRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Achievement Value",
        field: 'achievementValue',
        sortable: true,
        headerTooltip: 'Achievement Value',
        width: 130,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.achievementValueRaw || 0;
            const numB = nodeB.data.achievementValueRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Achievement Percentage",
        field: 'achievementPercentage',
        sortable: true,
        headerTooltip: 'Achievement Percentage',
        width: 130,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.achievementPercentageRaw || 0;
            const numB = nodeB.data.achievementPercentageRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Employee Expenses",
        field: 'empExpensPerMonth',
        sortable: true,
        headerTooltip: 'Employee Expenses',
        width: 160,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.empExpensPerMonthRaw || 0;
            const numB = nodeB.data.empExpensPerMonthRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "Incentive",
        field: 'incentivePerMonth',
        sortable: true,
        headerTooltip: 'Incentive',
        width: 130,
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.incentivePerMonthRaw || 0;
            const numB = nodeB.data.incentivePerMonthRaw || 0;
            return numA - numB;
        },
    },
];
export const BrandWiseStoreSalesHeader = [
    {
        headerName: "Store Name",
        field: 'nameStore',
        sortable: true,
        headerTooltip: 'Store Name',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 250,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Latest Invoice Date",
        field: 'invDate',
        headerTooltip: 'Latest Invoice Date',
        width: 120
    },
    {
        headerName: "Last Updated Date",
        field: 'lastUpdated',
        headerTooltip: 'Last Updated Date',
        width: 130
    },
    {
        headerName: "Net Unit Sold",
        field: 'netUnitSold',
        sortable: true,
        headerTooltip: 'Net Unit Sold',
        width: 100
    },
    {
        headerName: "Total MRP Value",
        field: 'mrpValue',
        sortable: true,
        headerTooltip: 'Total MRP Value',
        width: 180
    },
    {
        headerName: "Discount",
        field: 'discount',
        sortable: true,
        headerTooltip: 'Discount',
    },
    {
        headerName: "Gross Sales",
        field: 'grossSale',
        sortable: true,
        headerTooltip: 'Gross Sales',
    },
    {
        headerName: "Net Sales",
        field: 'netSale',
        sortable: true,
        headerTooltip: 'Net Sales',
    },
    {
        headerName: "ASP",
        field: 'asp',
        sortable: true,
        headerTooltip: 'ASP',
        width: 120
    },
    {
        headerName: "Count of bill",
        field: 'cob',
        sortable: true,
        headerTooltip: 'Count of bill',
        width: 120
    },
    {
        headerName: "ATV",
        field: 'asv',
        sortable: true,
        headerTooltip: 'ATV',
        width: 120
    },
    {
        headerName: "BS",
        field: 'bs',
        sortable: true,
        headerTooltip: 'BS',
        width: 100
    },
    {
        headerName: "Sell Through",
        field: 'sellThrough',
        sortable: true,
        headerTooltip: 'Sell Through',
        width: 150
    },
    {
        headerName: "Return Unit",
        field: 'returnUnit',
        sortable: true,
        headerTooltip: 'Return Unit',
        width: 110
    },
    {
        headerName: "Return Value",
        field: 'returnValue',
        sortable: true,
        headerTooltip: 'Return Value',
    },
    // {
    //     headerName: "Sale Before Tax",
    //     field: 'saleBeforeTax',
    //     sortable: true,
    //     headerTooltip: 'Sale Before Tax',
    // },
    {
        headerName: "Total Tgt Value",
        field: 'totalTgtValue',
        sortable: true,
        headerTooltip: 'Total Tgt Value',
        width: 130,
    },
    {
        headerName: "Achievement Value",
        field: 'achievementValue',
        sortable: true,
        headerTooltip: 'Achievement Value',
        width: 130,
    },
    {
        headerName: "Achievement Percentage",
        field: 'achievementPercentage',
        sortable: true,
        headerTooltip: 'Achievement Percentage',
        width: 130,
    },
]

export const storeSalesTableHeader = [
    {
        headerName: "Store Name",
        field: 'nameStore',
        sortable: true,
        headerTooltip: 'Store Name',
        filter: true,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Latest Invoice Date",
        field: 'invDate',
        headerTooltip: 'Latest Invoice Date',
    },
    {
        headerName: "Last Updated Date",
        field: 'lastUpdated',
        headerTooltip: 'Last Updated Date',
    },
    {
        headerName: "Gap (In Days)",
        field: 'gap',
        sortable: true,
        headerTooltip: 'Gap (In Days)',
    },
]
export const stockDashboardTableHeader = [
    {
        headerName: "Store Name",
        field: 'nameStore',
        sortable: true,
        headerTooltip: 'Store Name',
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
        },
    },
    // {
    //     headerName: "Stock as On",
    //     field: 'stockAsOn',
    //     sortable: true,
    //     headerTooltip: 'Stock as On',
    // },
    {
        headerName: "Latest Invoice Date",
        field: 'lastUpdated',
        sortable: true,
        headerTooltip: 'Latest Invoice Date',
    },
    {
        headerName: "Last Report Date",
        field: 'lastSaleDate',
        sortable: true,
        headerTooltip: 'Last Report Date',
    },
    {
        headerName: "Stock Quantity",
        field: 'stockQuantity',
        sortable: true,
        headerTooltip: 'Stock Quantity',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.stockQuantityRaw || 0;
            const numB = nodeB.data.stockQuantityRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "MRP Value",
        field: 'totalMRP',
        sortable: true,
        headerTooltip: 'MRP Value',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.totalMRPRaw || 0;
            const numB = nodeB.data.totalMRPRaw || 0;
            return numA - numB;
        },
    },
    {
        headerName: "MDQ",
        field: 'MDQ',
        sortable: true,
        headerTooltip: 'MDQ',
    },
    // {
    //     headerName: "Broken Size",
    //     field: 'brokenSize',
    //     sortable: true,
    //     headerTooltip: 'Broken Size',
    // },
    // {
    //     headerName: "Pivotal Size",
    //     field: 'pivotalSize',
    //     sortable: true,
    //     headerTooltip: 'Pivotal Size',
    // },
    // {
    //     headerName: "Current Stock",
    //     field: 'currentStock',
    //     sortable: true,
    //     headerTooltip: 'Current Stock',
    // },
    {
        headerName: "Sold Out Count",
        field: 'soldOutCount',
        sortable: true,
        headerTooltip: 'Sold Out Count',
        comparator: (valueA, valueB, nodeA, nodeB) => {
            const numA = nodeA.data.soldOutCountRaw || 0;
            const numB = nodeB.data.soldOutCountRaw || 0;
            return numA - numB;
        },
    },
]

export const stockDashboardDetailedTableHeader = [
    {
        headerName: "Store Name",
        field: 'storeName',
        sortable: true,
        headerTooltip: 'Store Name',
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
        },
    },
    {
        headerName: "Barcode",
        field: 'barcode',
        sortable: false,
        headerTooltip: 'Barcode',
    },
    {
        headerName: "Category",
        field: 'category',
        sortable: false,
        headerTooltip: 'Category',
    },
    {
        headerName: "Season",
        field: 'season',
        sortable: false,
        headerTooltip: 'Season',
    },
    {
        headerName: "Color",
        field: 'color',
        sortable: false,
        headerTooltip: 'Color',
    },
    {
        headerName: "Size",
        field: 'size',
        sortable: false,
        headerTooltip: 'Size',
    },
    {
        headerName: "Remaining Quantity",
        field: 'stockQuantity',
        sortable: true,
        headerTooltip: 'Remaining Quantity',
    },
    {
        headerName: "Sold Quantity",
        field: 'soldQuantity',
        sortable: true,
        headerTooltip: 'Sold Quantity',
    },
]

export const TargetVsAchievementTableHeader = [
    {
        headerName: "Store Name",
        field: 'nameStore',
        sortable: true,
        headerTooltip: 'Store Name',
        width: 200,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Store Code",
        field: 'storeCode',
        sortable: true,
        headerTooltip: 'Store Code',
        width: 150,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Month",
        field: 'month',
        sortable: true,
        filter: false,
        headerTooltip: 'Month',
    },
    {
        headerName: "Region",
        field: 'region',
        sortable: true,
        filter: false,
        headerTooltip: 'Region',
        width: 150,
    },
    {
        headerName: "State",
        field: 'state',
        sortable: true,
        filter: false,
        headerTooltip: 'State',
        width: 150,
    },
    {
        headerName: "Reportee Name",
        field: 'reporteeName',
        sortable: true,
        filter: false,
        headerTooltip: 'Reportee Name',
        width: 150,
    },
    {
        headerName: "FL Name",
        field: 'flName',
        sortable: true,
        filter: false,
        headerTooltip: 'FL Name',
        width: 150,
    },
    {
        headerName: "FL Status",
        field: 'flStatus',
        sortable: true,
        headerTooltip: 'FL Status',
        width: 150,
        filter: false,
    },
    {
        headerName: "Sell Thru",
        field: 'sellThru',
        sortable: true,
        headerTooltip: 'Sell Thru',
        width: 150,
        filter: false,
    },
    {
        headerName: "Total Tgt Value",
        field: 'totalTgtValue',
        sortable: true,
        headerTooltip: 'Total Tgt Value',
        width: 150,
        filter: false,
    },
    {
        headerName: "Total Tgt QTY",
        field: 'totalTgtQty',
        sortable: true,
        headerTooltip: 'Total Tgt QTY',
        width: 150,
        filter: false,
    },
    {
        headerName: "Achievement Value",
        field: 'achievementValue',
        sortable: true,
        headerTooltip: 'Achievement Value',
        width: 150,
        filter: false,
    },
    {
        headerName: "Achievement Percentage",
        field: 'achievementPercentage',
        sortable: true,
        headerTooltip: 'Achievement Percentage',
        width: 150,
        filter: false,
    },
    {
        headerName: "Action",
        field: 'targetAction',
        sortable: false,
        headerTooltip: 'Action',
        filter: false,
    },
]

export const IncetiveDashboardTableHeader = [
    {
        headerName: "Store Name",
        field: 'nameStore',
        sortable: true,
        headerTooltip: 'Store Name',
        width: 200,
    },
    {
        headerName: "Employee Name",
        field: 'employeeName',
        sortable: true,
        headerTooltip: 'Employee Name',
        width: 150,
    },
    {
        headerName: "Designation",
        field: 'designation',
        sortable: true,
        headerTooltip: 'Designation',
        width: 120,
    },
    {
        headerName: "Brand Name",
        field: 'nameBrand',
        sortable: true,
        headerTooltip: 'Brand Name',
        width: 120,
    },
    {
        headerName: "Month",
        field: 'month',
        sortable: true,
        headerTooltip: 'Month',
        width: 120,
    },
    {
        headerName: "No. of Bill",
        field: 'noOfBill',
        sortable: true,
        headerTooltip: 'No. of Bill',
        width: 120,
    },
    {
        headerName: "Quantity",
        field: 'quantity',
        sortable: true,
        headerTooltip: 'Quantity',
        width: 120,
    },
    {
        headerName: "Gross Sales Value",
        field: 'grossSaleValue',
        sortable: true,
        headerTooltip: 'Gross Sales Value',
        width: 120,
    },
    {
        headerName: "Target",
        field: 'target',
        sortable: true,
        headerTooltip: 'Target',
        width: 120,
    },
    {
        headerName: "Achievement %",
        field: 'achievementPerCent',
        sortable: true,
        headerTooltip: 'Achievement %',
        width: 150,
    },
    {
        headerName: "Monthly Incentive",
        field: 'monthlyIncentive',
        sortable: true,
        headerTooltip: 'Monthly Incentive',
        width: 180,
    },
    {
        headerName: "WOW Bill Incentive",
        field: 'WOWBillIncentive',
        sortable: true,
        headerTooltip: 'WOW Bill Incentive',
        width: 180,
    },
    {
        headerName: "Special Incentive",
        field: 'specialIncentive',
        sortable: true,
        headerTooltip: 'Special Incentive',
        width: 150,
    },
    {
        headerName: "Total Incentive",
        field: 'totalIncentive',
        sortable: true,
        headerTooltip: 'Total Incentive',
        width: 150,
    },
]

export const PromotionDashboardTableHeader = [
    {
        headerName: "Batch Description",
        field: 'description',
        sortable: true,
        headerTooltip: 'Batch Description',
    },
    {
        headerName: "Brand Name",
        field: 'brand_data',
        sortable: true,
        headerTooltip: 'Brand Name',
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        // width: 120
    },
    // {
    //     headerName: "Region",
    //     field: 'region',
    //     sortable: true,
    //     headerTooltip: 'Region',
    //     filter: true,
    //     filterParams: {
    //         buttons: ["reset", "apply"],
    //         filterOptions: ["contains"],
    //         suppressAndOrCondition: true,
    //     },
    //     // width: 120
    // },
    // {
    //     headerName: "State",
    //     field: 'state',
    //     sortable: true,
    //     headerTooltip: 'State',
    //     filter: true,
    //     filterParams: {
    //         buttons: ["reset", "apply"],
    //         filterOptions: ["contains"],
    //         suppressAndOrCondition: true,
    //     },
    //     // width: 120
    // },
    {
        headerName: "Start Date",
        field: 'from_date',
        headerTooltip: 'Start Date',
        width: 110,
    },
    {
        headerName: "End Date",
        field: 'to_date',
        headerTooltip: 'End Date',
        width: 100,
    },
    {
        headerName: "Promo Code",
        field: 'promo_code',
        sortable: true,
        headerTooltip: 'Promo Code',
        width: 120,
    },
    {
        headerName: "Stores",
        field: 'store_detail',
        sortable: true,
        headerTooltip: 'Stores',
        // width : 270
    },
    {
        headerName: "Promotion Applied",
        field: 'promotion_type_value',
        sortable: true,
        headerTooltip: 'Promotion Applied',
        width: 200
    },
    {
        headerName: "Status",
        field: 'brandStatus',
        sortable: true,
        headerTooltip: 'Status',
        width: 100
    },
    {
        headerName: "Action",
        field: 'promotionAction',
        sortable: true,
        headerTooltip: 'Action',
        // width: 150
    },
]
export const ItemMasterHeader = [
    {
        headerName: "Barcode",
        field: 'barcode',
        headerTooltip: 'Barcode',
        sortable: true,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        width: 180
    },
    {
        headerName: "Product Code",
        field: 'styleCode',
        headerTooltip: 'Product Code',
        sortable: true,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        width: 150
    },
    {
        headerName: "Last Updated",
        field: 'lastUpdated',
        headerTooltip: 'Last Updated',
        // sortable: true,
        width: 150
    },
    {
        headerName: "Brand Name",
        field: 'nameBrand',
        headerTooltip: 'Brand Name',
        sortable: true,
        width: 150
    },
    {
        headerName: "Category Name",
        field: 'categoryDivision',
        headerTooltip: 'Category Name',
        sortable: true,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        width: 120
    },
    {
        headerName: "FIT",
        field: 'categoryGroup',
        headerTooltip: 'FIT',
        sortable: true,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        width: 120
    },
    {
        headerName: "Pattern",
        field: 'categorySection',
        headerTooltip: 'Pattern',
        sortable: true,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        width: 180
    },
    {
        headerName: "Brand Code",
        field: 'brandCode',
        headerTooltip: 'Brand Code',
        sortable: true,
        width: 90
    },
    {
        headerName: "Sub Brand",
        field: 'subBrand',
        headerTooltip: 'Sub Brand',
        sortable: true,
        width: 130
    },
    {
        headerName: "Department",
        field: 'department',
        headerTooltip: 'Department',
        sortable: true,
        width: 120
    },
    {
        headerName: "Category Code",
        field: 'catCode',
        headerTooltip: 'Category Code',
        sortable: true,
        width: 100
    },
    {
        headerName: "Merchandise Hierarchy",
        field: 'merchandiseHierarchy',
        headerTooltip: 'Merchandise Hierarchy',
        sortable: true,
    },
    {
        headerName: "Product SKU Code",
        field: 'ProSKUCode',
        headerTooltip: 'Product SKU Code',
        sortable: true,
        width: 150
    },
    {
        headerName: "Product SKU Desc",
        field: 'ProdSKUDesc',
        headerTooltip: 'Product SKU Desc',
        sortable: true,
    },
    {
        headerName: "HSN Code",
        field: 'HSNCode',
        headerTooltip: 'HSN Code',
        sortable: true,
        width: 150

    },
    {
        headerName: "UOM",
        field: 'UOM',
        headerTooltip: 'UOM',
        sortable: true,
        width: 100
    },
    {
        headerName: "Colour",
        field: 'color',
        headerTooltip: 'Colour',
        sortable: true,
        width: 120
    },
    {
        headerName: "Size",
        field: 'size',
        headerTooltip: 'Size',
        sortable: true,
        width: 100
    },
    {
        headerName: "Season",
        field: 'season',
        headerTooltip: 'Season',
        sortable: true,
        width: 120
    },
    {
        headerName: "Product Type",
        field: 'productType',
        headerTooltip: 'Product Type',
        sortable: true,
        width: 120
    },
    {
        headerName: "MH1 Description",
        field: 'MH1Description',
        headerTooltip: 'MH1 Description',
        sortable: true,
        width: 120
    },
    {
        headerName: "MH2 Description",
        field: 'MH2Description',
        headerTooltip: 'MH2 Description',
        sortable: true,
        width: 120
    },
    {
        headerName: "MH3 Description",
        field: 'MH3Description',
        headerTooltip: 'MH3 Description',
        sortable: true,
        width: 120
    },
    {
        headerName: "MH4 Description",
        field: 'MH4Description',
        headerTooltip: 'MH4 Description',
        sortable: true,
        width: 120
    },
    {
        headerName: "MH5 Description",
        field: 'MH5Description',
        headerTooltip: 'MH5 Description',
        sortable: true,
        width: 120
    },
    {
        headerName: "VARIANT - I",
        field: 'VARIANT1',
        headerTooltip: 'VARIANT - I',
        sortable: true,
        width: 120
    },
    {
        headerName: "VARIANT - II",
        field: 'VARIANT2',
        headerTooltip: 'VARIANT - II',
        sortable: true,
        width: 120
    },
    {
        headerName: "VARIANT - III",
        field: 'VARIANT3',
        headerTooltip: 'VARIANT - III',
        sortable: true,
        width: 120
    },
    {
        headerName: "ATTRIBUTE - I",
        field: 'ATTRIBUTE1',
        headerTooltip: 'ATTRIBUTE - I',
        sortable: true,
        width: 120
    },
    {
        headerName: "ATTRIBUTE - II",
        field: 'ATTRIBUTE2',
        headerTooltip: 'ATTRIBUTE - II',
        sortable: true,
        width: 120
    },
    {
        headerName: "ATTRIBUTE - III",
        field: 'ATTRIBUTE3',
        headerTooltip: 'ATTRIBUTE - III',
        sortable: true,
        width: 120
    },
    {
        headerName: "ATTRIBUTE - IV",
        field: 'ATTRIBUTE4',
        headerTooltip: 'ATTRIBUTE - IV',
        sortable: true,
        width: 120
    },
    {
        headerName: "ATTRIBUTE - V",
        field: 'ATTRIBUTE5',
        headerTooltip: 'ATTRIBUTE - V',
        sortable: true,
        width: 120
    },
    {
        headerName: "Season Code",
        field: 'seasonCode',
        headerTooltip: 'Season Code',
        sortable: true,
        width: 120
    },
    {
        headerName: "Season Description",
        field: 'seasonDesc',
        headerTooltip: 'Season Description',
        sortable: true,
        width: 120
    },
    {
        headerName: "ATTRIBUTE - VI",
        field: 'ATTRIBUTE6',
        headerTooltip: 'ATTRIBUTE - VI',
        sortable: true,
        width: 120
    },
    {
        headerName: "ATTRIBUTE – VII",
        field: 'ATTRIBUTE7',
        headerTooltip: 'ATTRIBUTE – VII',
        sortable: true,
        width: 120
    },
    {
        headerName: "Cost",
        field: 'Cost',
        headerTooltip: 'Cost',
        sortable: true,
        width: 120
    },
    {
        headerName: "MRP",
        field: 'MRP',
        headerTooltip: 'MRP',
        sortable: true,
        width: 120
    },
    {
        headerName: "Discount",
        field: 'Discount',
        headerTooltip: 'Discount',
        sortable: true,
        width: 120
    },
    {
        headerName: "Offer Price",
        field: 'offerPrice',
        headerTooltip: 'Offer Price',
        sortable: true,
        width: 120
    },
];
export const ReconReportHeader = [
    // {
    //     headerName: "Store Code",
    //     field: 'codeStore',
    //     headerTooltip: 'Store Code',
    //     sortable: true,
    //     filter: true,
    //     width: 195,
    //     filterParams: {
    //         buttons: ["reset", "apply"],
    //         filterOptions: ["contains"],
    //         suppressAndOrCondition: true,
    //     },
    // },
    {
        headerName: "Store Name",
        field: 'nameStore',
        headerTooltip: 'Store Name',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        sortable: true,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        width: 300,
    },
    {
        headerName: "Last Invoice Date",
        field: 'lastInvDate',
        headerTooltip: 'Last Invoice Date',
    },
    {
        headerName: "Last Mail Sent On",
        field: 'lastMailSent',
        headerTooltip: 'Last Mail Sent On',
    },
    {
        headerName: "Updated On",
        field: 'updatedOn',
        headerTooltip: 'Updated On',
    },
    {
        headerName: "Download File",
        field: 'reconFileDownload',
        headerTooltip: 'Download File',
    },
    {
        headerName: "View",
        field: 'reconFileViewDetails',
        headerTooltip: 'View Details',
        width: 100,
    },
    // {
    //     headerName: "YTD Reports",
    //     field: 'ytdReconReport',
    //     headerTooltip: 'YTD Reports',
    //     width: 120
    // },

];
export const BrandReconReportHeader = [
   
    {
        headerName: "Check Box",
        field: 'Check Box',
       
        headerCheckboxSelection: true,
        checkboxSelection: true,
       
       
        
    },
    {
        headerName: "Header List",
        field: 'Header list',
        headerTooltip: 'Header list',
    },
    {
        headerName: "Label",
        field: 'Label',
        headerTooltip: 'Label',
    },
    {
        headerName: "Color Picker",
        field: 'Color',
        headerTooltip: 'Color',
        
    },
    {
        headerName: "Description",
        field: 'Description',
        headerTooltip: 'Description',
       
    },

];
export const StockBrokenSizeHeader = [
    {
        headerName: "Store Name",
        field: 'storeN',
        headerTooltip: 'Store Name',
        sortable: true,
    },
    // {
    //     headerName: "Regions",
    //     field: 'regions',
    //     headerTooltip: 'Regions',
    //     sortable: true,
    // },
    // {
    //     headerName: "State",
    //     field: 'states',
    //     headerTooltip: 'State',
    // },
    {
        headerName: "Store Code",
        field: 'storeC',
        headerTooltip: 'Store Code',
    },
    {
        headerName: "Status",
        field: 'status',
        headerTooltip: 'Status',
    },
    {
        headerName: "File Link",
        field: 'fileLink',
        headerTooltip: 'File Link',
    },

];
export const EmployeeStatusHeader = [
    {
        headerName: "Employee ID",
        field: 'emplId',
        headerTooltip: 'Employee ID',
        sortable: true,
        filter: true,
    },
    {
        headerName: "User Name",
        field: 'nameUser',
        headerTooltip: 'User Name',
        sortable: true,
        filter: true,
    },
    {
        headerName: "Store Name",
        field: 'emplStoreName',
        headerTooltip: 'Store Name',
        sortable: true,
        filter: true,
    },
    {
        headerName: "Absent Since",
        field: 'lastPresentSince',
        headerTooltip: 'Absent Since',
        sortable: true,
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
    },
    {
        headerName: "Present Day",
        field: 'presentDay',
        headerTooltip: 'Present Day',
        sortable: false,
    },
    {
        headerName: "Absent Day",
        field: 'absentDay',
        headerTooltip: 'Absent Day',
        sortable: false,
    },
    {
        headerName: "Total Sales Count",
        field: 'totalSalesCount',
        headerTooltip: 'Total Sales Count',
        sortable: false,
    },
    {
        headerName: "Action",
        field: 'employeeStatusaction',
        headerTooltip: 'Action',
        sortable: false,
    },

];
export const EmployeeStatusSalesDetailsHeader = [

    {
        headerName: "Brand Name",
        field: 'nameBrand',
        headerTooltip: 'Brand Name',
        sortable: true,
        filter: true,
    },
    {
        headerName: "Store Name",
        field: 'nameStore',
        headerTooltip: 'Store Name',
        sortable: true,
        filter: true,
    },
    // {
    //     headerName: "Status",
    //     field: 'employeeSalesStatus',
    //     headerTooltip: 'Status',
    //     sortable: true,
    //     filter: true,
    // },
    {
        headerName: "Barcode",
        field: 'barcode',
        headerTooltip: 'Barcode',
        sortable: true,
        filter: true,
    },
    {
        headerName: "Invoice Date",
        field: 'invoiceDate',
        headerTooltip: 'Invoice Date',
        sortable: true,
        // filter: true,
    },
    {
        headerName: "Category",
        field: 'category',
        headerTooltip: 'Category',
        sortable: true,
        filter: true,
    },
    {
        headerName: "Sub Category",
        field: 'subCategory',
        headerTooltip: 'Sub Category',
        sortable: true,
        filter: true,
    },

    // {
    //     headerName: "Product Type",
    //     field: 'productType',
    //     headerTooltip: 'Product Type',
    // },
    {
        headerName: "Color",
        field: 'color',
        headerTooltip: 'Color',
        sortable: true,
        filter: true,
    },
    {
        headerName: "Size",
        field: 'size',
        headerTooltip: 'Size',
        sortable: true,
        filter: true,
    },
    {
        headerName: "Pack Of",
        field: 'packOf',
        headerTooltip: 'Pack Of',
        sortable: true,
        filter: true,
    },
    {
        headerName: "MRP",
        field: 'MRP',
        headerTooltip: 'MRP',
        sortable: true,
        filter: true,
    },

];
export const notificationTableHeader = [

    {
        headerName: "Notification Subject",
        field: 'notiSub',
        headerTooltip: 'Notification Subject',
        // sortable: true,
        // filter: true,
    },
    {
        headerName: "Notification Body",
        field: 'notiBody',
        headerTooltip: 'Notification Body',
        // sortable: true,
        // filter: true,
    },
    {
        headerName: "Date",
        field: 'date',
        headerTooltip: 'Date',
    },
    // {
    //     headerName: "Time",
    //     field: 'time',
    //     headerTooltip: 'Time',
    // },
    {
        headerName: "Action",
        field: 'notiAction',
        headerTooltip: 'Action',
    },

];

export const FileCenterTableHeader = [
    {
        headerName: "Brand Name",
        field: 'brand_name',
        sortable: true,
        headerTooltip: 'Brand Name',
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        // width: 120
    },
    {
        headerName: "Store Name",
        field: 'store_name',
        sortable: true,
        headerTooltip: 'Store Name',
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        // width: 120
    },
    {
        headerName: "Report Type",
        field: 'report_type',
        sortable: false,
        headerTooltip: 'Report Type',
        filter: false,
        width: 120,
    },
    {
        headerName: "File Name",
        field: 'file_name',
        sortable: false,
        headerTooltip: 'File Name',
        filter: true,
        filterParams: {
            buttons: ["reset", "apply"],
            filterOptions: ["contains"],
            suppressAndOrCondition: true,
        },
        width: 250
    },
    {
        headerName: "Service Type",
        field: 'service_type',
        sortable: false,
        headerTooltip: 'Service Type',
        width : 150
    },
    {
        headerName: "Sender Email",
        field: 'sender_email',
        sortable: true,
        headerTooltip: 'Sender Email',
        width: 250
    },
    {
        headerName: "File Received On",
        field: 'created_at',
        sortable: true,
        headerTooltip: 'File Received On',
        width: 150
    },
    {
        headerName: "Status",
        field: 'status',
        sortable: true,
        headerTooltip: 'Status',
        width: 100
    },
    {
        headerName: "Comment",
        field: 'comment',
        sortable: false,
        headerTooltip: 'Comment',
        width: 300,
        autoHeight: true, // This enables auto height for this column
        cellStyle: {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: '1.4',
        }
    },
    {
        headerName: "Action",
        field: 'action',
        sortable: false,
        headerTooltip: 'Action',
        actionFor: 'file-center',
        // width: 150
    },
];

export const storeNamePopupTableHeader = [
    {
        headerName: "S.No",
        field: 'sno',
        width: 80
    },
    {
        headerName: "Store Name",
        field: 'store_name',
        width: 300
    },
];
